import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { PortfolioProvider } from "./state/PortfolioContext";
import { initAnalytics } from "./infrastructure/analytics";
import "./styles.css";

const root = document.getElementById("root")!;
const application = (
  <React.StrictMode>
    <BrowserRouter>
      <PortfolioProvider>
        <App />
      </PortfolioProvider>
    </BrowserRouter>
  </React.StrictMode>
);

if (root.hasChildNodes()) hydrateRoot(root, application);
else createRoot(root).render(application);

initAnalytics();

